var React = require('react');

function Screen (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"8.5","y":"11.5","width":"40","height":"27","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9 34H48M15.5 45.5H41.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M32 38V45","key":2}),React.createElement("path",{"d":"M25 38V45","key":3})]);
}

Screen.defaultProps = {"width":"57","height":"57","viewBox":"0 0 57 57","stroke":"#231F20","fill":"none"};

module.exports = Screen;

Screen.default = Screen;
